import { render, staticRenderFns } from "./softPromotionLayout.vue?vue&type=template&id=4259073d&scoped=true&"
import script from "./softPromotionLayout.vue?vue&type=script&lang=js&"
export * from "./softPromotionLayout.vue?vue&type=script&lang=js&"
import style0 from "./softPromotionLayout.vue?vue&type=style&index=0&id=4259073d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4259073d",
  null
  
)

export default component.exports